import React from 'react';
import { Shield, Mail, Clock, Facebook, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-slate-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Shield className="w-8 h-8 text-teal-400" />
              <div>
                <span className="text-xl font-bold text-white">PIGNUS</span>
                <span className="text-xl font-light text-teal-400 italic ml-1">DETEKTIV</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {companyInfo.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Snabblänkar</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">
                  Hem
                </Link>
              </li>
              <li>
                <Link to="/tjanster" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">
                  Tjänster
                </Link>
              </li>
              <li>
                <Link to="/om-oss" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">
                  Om oss
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Kontaktinformation</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <a href={`mailto:${companyInfo.email}`} className="text-gray-400 hover:text-teal-400 text-sm transition-colors">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Clock className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <p className="text-gray-400 text-sm">{companyInfo.openingHours}</p>
              </li>
              <li className="flex items-start space-x-3">
                <div className="flex items-center space-x-3 mt-2">
                  <a 
                    href={companyInfo.socialMedia.facebook}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-all duration-300"
                    aria-label="Facebook"
                  >
                    <Facebook className="w-5 h-5 text-teal-400 hover:text-white" />
                  </a>
                  <a 
                    href={companyInfo.socialMedia.instagram}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-all duration-300"
                    aria-label="Instagram"
                  >
                    <Instagram className="w-5 h-5 text-teal-400 hover:text-white" />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800">
          <p className="text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} Pignus Detektivbyrå. Alla rättigheter förbehållna.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;